import { Environment, getHostname, isCloverDevEnvironment, isCloverStagingEnvironment, isDevHost } from './Environment';
import { CLIENT_PATH, HOSTNAME, SERVER_PATH } from 'olo-service/axiosInstance';

export const OLO_IPG_TOKEN = 'IPG';
export const STG_IPG_URL = 'https://test.ipg-online.com/connect/gateway/processing';
export const DEV_IPG_URL = 'https://test2.ipg-online.com/connect/gateway/processing';

export const PRODUCTION_IPG_URL = 'https://www.ipg-online.com/connect/gateway/processing';

export const WEB_HOSTNAME = [`${window.location.protocol}//${getHostname()}`, window.location.port].filter(s => !!s).join(':');

export const isPaymentProcessorIpg = (paymentMethods?: string[]) => {
  if (!paymentMethods) return false;

  return paymentMethods.includes(OLO_IPG_TOKEN);
};

export const isOnlyIpgProcess = (paymentMethods?: string[]) => {
  if (!paymentMethods || paymentMethods.length !== 1) return false;

  return paymentMethods[0] === OLO_IPG_TOKEN;
};

export const getIpgPaymentUrl = (env: Environment, hostname: string = getHostname()) => {
  if (env === 'development' || isCloverDevEnvironment(hostname) || isDevHost(hostname)) return DEV_IPG_URL;
  if (isCloverStagingEnvironment(hostname)) return STG_IPG_URL;

  return PRODUCTION_IPG_URL;
};

export const getIpgTransactionNotificationUrl = (receiptId: string, slug: string = '') => {
  return `${HOSTNAME}/${SERVER_PATH}/${slug}/orders/${receiptId}/ipg_payments?slug=true`;
};

export const getIpgResponseFailURL = (slug: string = '') => {
  return `${WEB_HOSTNAME}/${CLIENT_PATH}/${slug}/checkout?error=true`;
};

export const getIpgResponseSuccessURL = (receiptId: string, slug: string = '', estimatedTime: string = '') => {
  return `${WEB_HOSTNAME}/${CLIENT_PATH}/${slug}/status?processor=ipg&receiptId=${receiptId}&estTime=${encodeURIComponent(estimatedTime)}`;
};
